import dayjs from "dayjs";

export function formatDate(date: string | undefined | null): string {
	if (!date) {
		return "—";
	}
	return dayjs(date).format("DD.MM.YYYY");
}

export function formatPrice(price: string | undefined | null): string {
	if (price === undefined || price === null || price === "") {
		return "—";
	}
	const num = Number(price);
	if (Number.isNaN(num)) {
		return price;
	}
	return `${num.toLocaleString("ru-RU")} so'm`;
}
